import { render, staticRenderFns } from "./MinimalLayout.vue?vue&type=template&id=49c245a6&scoped=true&"
import script from "./MinimalLayout.vue?vue&type=script&lang=js&"
export * from "./MinimalLayout.vue?vue&type=script&lang=js&"
import style0 from "./MinimalLayout.vue?vue&type=style&index=0&id=49c245a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c245a6",
  null
  
)

/* custom blocks */
import block0 from "./MinimalLayout.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VIcon})
